import classNames from 'classnames';

import styles from './styles.module.scss';

/** Underline tab switcher. `tabs` is [{ id, label }]. */
const Tabs = ({ tabs, active, onChange, label = '' }) => (
    <div className={styles.tabs} role="tablist" aria-label={label}>
        {tabs.map((tab) => {
            const selected = tab.id === active;
            return (
                <button
                    key={tab.id}
                    id={`bc-tab-${tab.id}`}
                    type="button"
                    role="tab"
                    aria-selected={selected}
                    aria-controls={`bc-panel-${tab.id}`}
                    className={classNames(styles.tab, { [styles.tabActive]: selected })}
                    onClick={() => onChange(tab.id)}
                >
                    {tab.label}
                    {tab.icon}
                </button>
            );
        })}
    </div>
);

export default Tabs;
